export enum EAdminProjectQueryKey {
  ADMIN_PROJECT = 'admin-project',
  ADMIN_SET_PROJECT_DEFAULT_PHOTO = 'admin-set-project-default-photo',
  ADMIN_UPDATE_PROJECT_AGENT_LINK_STATUS = 'admin-update-project-agent-link-status',
  ADMIN_LIST_PROJECT_AGENT_LINKS = 'admin-list-project-agent-links',
  ADMIN_GET_PROJECT_AGENT_LINKS = 'admin-get-project-agent-links',
}
